import React from 'react';
import { MinicartProps } from './@types/MinicartProps';
import MinicartProvider from '../Minicart/hooks/useMinicart';
import MinicartFixedContent from './handles/MinicartFixedContent';
import MinicartWrapperContainer from '../Minicart/handles/MinicartWrapperContainer';
import MinicartContainer from '../Minicart/handles/MinicartContainer';
import MinicartIconContainer from '../Minicart/handles/MinicartIconContainer';
import OpenIconContainer from '../Minicart/handles/OpenIconContainer';
import ShoppingCart from '@vtex/styleguide/lib/icon/ShoppingCart';
import MinicartQuantityBadge from '../Minicart/handles/MinicartQuantityBadge';
import OpenMinicartContextProvider, { useOpenMinicartContextProvider } from '../openMinicartContextProvider';
import './Minicart.scss';
import Overlay from '../Minicart/handles/Overlay';
import { Portal } from '@chakra-ui/react';

const MinicartFixed = (props: MinicartProps) => {
	return (
		<OpenMinicartContextProvider>
			<MinicartProvider {...props}>
				<MinicartWrapperContainer>
					<MinicartContainer>
						<OpenIconContainer>
							<MinicartIconContainer>
								<ShoppingCart />
								<MinicartQuantityBadge>3</MinicartQuantityBadge>
							</MinicartIconContainer>
						</OpenIconContainer>
					</MinicartContainer>
				</MinicartWrapperContainer>

				<MinicartPortalWrapper />
			</MinicartProvider>
		</OpenMinicartContextProvider>
	);
};

const MinicartPortalWrapper = () => {
	const canvasRef = React.useRef<HTMLDivElement | null>(null);
	React.useEffect(() => {
		const iframe = document.querySelector('iframe')?.contentDocument;
		canvasRef.current = iframe?.querySelector('.canvas') || document.querySelector('.canvas');
	}, []);

	const { isOpen, setIsOpen } = useOpenMinicartContextProvider();

	const handleClick = () => {
		setIsOpen(!isOpen);
	};
	return (
		<Portal containerRef={canvasRef}>
			{isOpen && <Overlay handleClick={handleClick} />}
			<MinicartFixedContent {...{ isOpen, handleClick }} />
		</Portal>
	);
};

export default MinicartFixed;
